<script context="module">
  import ProductInventory from "./ProductInventory.svelte";
  import {External, M} from "../../external";

  export function editProductInventory(product, onDone) {
    External.Tools.showWindow({
      title: M.TRACK_INVENTORY,
      width: 500,
      isModal: false,
      withDarkBackground: true,
      forceAtRight: External.showBuilderPopupsOnFullHeight,
      action: {
        onShow: (popup, context) => {
          popup.bindComponent(
            new ProductInventory({
              target: popup.getContentArea(),
              props: {
                product: product
              }
            })
          );
        },
        onHide: (popup, ui) => {
          onDone();
        }
      }
    });
  }
</script>

<script>
  import { onMount } from "svelte";

  export let product;
  let hasCombinations = false;

  onMount(() => {
    if (product.type === External.STORE_PRODUCT_TYPE.DIGITAL_PRODUCT || product.type === External.STORE_PRODUCT_TYPE.MEMBERSHIP) {
      hasCombinations = false;
    } else {
      hasCombinations = product.combinations && product.combinations.length > 0;
    }
  });
</script>

<div class="members-wrapper">
  <div class="store-products product-content col20 f-left">
    <div class="box col20 variations-box f-left col20 f-left" style="width: 100%">
      {#if hasCombinations}
        <div class="col20 f-left combination-table-wrapper">
          <table class="variation-info col20 f-left">
            <thead>
              <tr>
                <th class="col7">{M.COMBINATION}</th>
                <th class="col7">{M.SKU}</th>
                <th class="col6">{M.AVAILABLE_IN_STOCK}</th>
              </tr>
            </thead>
            <tbody>
              {#each product.combinations as combination}
                <tr>
                  <td class="col7"><span>{combination.name}</span></td>
                  <td class="col7">
                    <span>{combination.sku || "-"}</span>
                  </td>
                  <td class="col6"><input type="number" min="0" step="1" bind:value={combination.quantity} /></td>
                </tr>
              {/each}
            </tbody>
          </table>
        </div>
      {:else}
        <div class="inline-popup-wrapper" style="width:100%;">
          <h4>{M.AVAILABLE_IN_STOCK}</h4>
          <input type="number" min="0" step="1" bind:value={product.quantity} />
        </div>
      {/if}
    </div>
  </div>
</div>
